var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dashboard-block",staticStyle:{"width":"450px"}},[_c('h3',{staticClass:"container-heading text-center"},[_vm._v(" Références et GED créés 1er avril au 31 mars ")]),_c('div',{staticClass:"chart-area"},[_c('bar-chart',{ref:"chart",attrs:{"chart-data":_vm.chartData,"options":_vm.chartOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }